import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  styled,
} from "@mui/material";
import { Button, Typography } from "@platform/design-system";
import { Loader } from "@platform/portal-ui";

import { usePrompt } from "../../../hooks";
import { submitEvent } from "../../../utils/tracking";
import { UnsavedDocsBody } from "../steps/documents/modals/unsavedDocs";

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(3),
}));

function RfpWarning({
  open,
  onClose,
  state,
  exceptions,
  defaultLocation,
  defaultPrevPath,
  rfpId,
  isSavingDraftRfp,
  isBlockByPendingDoc,
}) {
  const [showPrompt, confirmNavigation, cancelNavigation] = usePrompt(
    open,
    defaultLocation,
    state,
    exceptions,
    defaultPrevPath,
  );

  const [isLeaving, setIsLeaving] = useState(false);

  const handleCancelNavigation = () => {
    if (isSavingDraftRfp) return;
    onClose();
    cancelNavigation();
  };

  const handleConfirmNavigation = (e) => {
    e.preventDefault();
    submitEvent("RFP Draft Exited", {
      rfp_id: rfpId,
    });
    onClose(true);
    setIsLeaving(true);
  };

  useEffect(() => {
    if (!isSavingDraftRfp && isLeaving) {
      confirmNavigation();
    }
  }, [isSavingDraftRfp, isLeaving, confirmNavigation]);

  return (
    <Dialog
      open={showPrompt || open}
      onClose={handleCancelNavigation}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"sm"}
    >
      {isBlockByPendingDoc ? (
        <UnsavedDocsBody
          onContinue={handleConfirmNavigation}
          onBackDocuments={handleCancelNavigation}
        />
      ) : (
        <>
          <DialogContent>
            <Typography variant="header-small" id="alert-dialog-title">
              Exit RFP
            </Typography>

            <Box mt={2} mb={3}>
              <DialogContentText id="alert-dialog-description">
                Your RFP will be saved as a draft with all selections and
                entered information. You can resume your work later.
              </DialogContentText>
            </Box>
          </DialogContent>
          <StyledDialogActions>
            {isSavingDraftRfp ? (
              <Box mt={6}>
                <Loader data-testid="loader" />
              </Box>
            ) : (
              <>
                <Button onClick={handleCancelNavigation} variant="tertiary">
                  Cancel
                </Button>
                <Button onClick={handleConfirmNavigation} variant="primary">
                  Exit RFP
                </Button>
              </>
            )}
          </StyledDialogActions>
        </>
      )}
    </Dialog>
  );
}

export default RfpWarning;
